import { Outlet } from 'react-router-dom';
import Header from './Header';
import ChatDrawer from './chat/ChatDrawer';

const Layout = () => {
  return (
    <div
      className="min-h-screen transition-colors duration-200"
      style={{ backgroundColor: 'var(--bg-primary)', color: 'var(--text-primary)' }}
    >
      <Header />
      <main className="content-container py-12">
        <Outlet />
      </main>
      <footer
        className="border-t mt-12 transition-colors duration-200"
        style={{ backgroundColor: 'var(--bg-secondary)', borderColor: 'var(--border-color)' }}
      >
        <div
          className="content-container py-6 text-center text-sm"
          style={{ color: 'var(--text-secondary)' }}
        >
          &copy; {new Date().getFullYear()} Alexander Machekhin. All rights reserved.
        </div>
      </footer>
      <ChatDrawer />
    </div>
  );
};

export default Layout;
